import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'

const {Search} = Input

class SearchField extends Component {
    _timeOut = null

    _handleChange = e => {
        const {value} = e.target

        if (this._timeOut) clearTimeout(this._timeOut)

        this._timeOut = setTimeout(() => {
            const {field, onChangeInput} = this.props
            onChangeInput(field, value)
        }, 500)
    }

    render() {
        const {placeholder, title, disabled, defaultValue} = this.props

        return (
            <div className='SearchField'>
                {title && <div className='mb-1 font-weight-bold'>{title}</div>}
                <Search placeholder={placeholder} defaultValue={defaultValue} onChange={this._handleChange} allowClear={true} disabled={disabled||false}/>
            </div>
        )
    }
}

SearchField.defautlProps = {
    placeholder: ''
}

SearchField.propTypes = {
    field: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    defaultValue: PropTypes.string,
}

export default SearchField
